import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
import moment from "moment";

export default (context) => {
  const M = "admRegist.";

  return {
    config: {
      pageSize: 40,
      resource: "admRegist",
      remapRow: (form) => form
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: false,
      export: true,
      search: true,
      import: {
        templateFile: "Registrations.xlsx"
      }
    },

    filter: {
      fields: [
        {
          name: "categoryId",
          value: null,
          type: "select",
          label: "main.category",
          opts: {
            style: "float-label",
            path: "/admCategory/get?type=act"
          }
        },
        {
          name: "activityPartId",
          value: null,
          type: "select",
          label: `${M}activityPart`,
          opts: {
            style: "float-label",
            path: "/admActivityParts/get?pick=true&type=act"
          }
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "main.grade",
          opts: {
            style: "float-label",
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          name: "sectionId",
          value: null,
          type: "select",
          label: "main.section",
          parent: "superSectionId",
          opts: {
            style: "float-label",
            path: () => "/admSection/get?pick=true&parentId=" + (context.state.formFilter?.superSectionId || "")
          },
          renderIf: (ctx) => ctx.state.superSectionId
        },
        {
          name: "from",
          value: moment().startOf("month").format("YYYY-MM-DD"),
          type: "date",
          label: "main.from",
          opts: {
            style: "float-label"
          }
        },
        {
          name: "to",
          value: moment().format("YYYY-MM-DD"),
          type: "date",
          label: "main.to",
          opts: {
            style: "float-label"
          }
        },
        {
          name: "masterId",
          value: null,
          type: "select",
          label: `${M}teacher`,
          opts: {
            style: "float-label",
            path: "/admStaff/get?pick=true&filterBy=type&filter=5"
          }
        },
        {
          name: "status",
          value: 1,
          type: "select",
          label: "main.status",
          rules: "required",
          opts: {
            style: "float-label",
            isClearable: false,
            items: [
              { value: 1, label: `${M}statusConfirmed` },
              { value: 0, label: `${M}statusCancelled` },
              { value: 2, label: `${M}statusSuspended` },
              { value: 3, label: `${M}statusExcluded` }
            ]
          }
        }
      ],
      buttons: [
        {
          label: "main.applyFilter",
          onClick: (ctx) => { ctx.btnAction("filter"); }
        }
      ]
    },

    form: {
      fields: [
        {
          col: 12,
          name: "userName",
          value: "",
          type: "label",
          label: "main.name"
        },
        {
          col: 12,
          name: "date",
          value: "",
          type: "label",
          label: "main.date"
        },
        {
          col: 12,
          name: "desc",
          value: "",
          type: "label",
          label: "main.desc"
        },
        {
          col: 12,
          name: "reprocess",
          value: null,
          type: "button",
          label: `${M}resendEmail`,
          opts: {
            style: "float-label"
          },
          onClick: () => {
            const id = context.state.idItemSelected;
            if (!id) return;
            context.props.setLoader(true);
            _axios.post("/admRegist/sendmail/" + id)
              .then((r) => {
                context.props.setLoader(false);
                NotificationManager[r.status >= 0 ? "success" : "error"](
                  r.msg || "",
                  r.status >= 0 ? "" : "Opps",
                  5000,
                  null,
                  null,
                  "outline"
                );
              })
              .catch((e) => {
                context.props.setLoader(false);
                NotificationManager.error(String(e), "Opps", 5000, null, null, "outline");
              });
          },
          renderIf: () => !!context.state.idItemSelected
        }
      ]
    },

    columns: [
      {
        Header: "main.externalId",
        accessor: "userExternalId"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: `${M}tag`,
        accessor: "usertag"
      },
      {
        Header: "main.date",
        accessor: "date",
        isDate: true
      },
      {
        Header: "main.activity",
        accessor: "activity"
      },
      {
        Header: `${M}activityPart`,
        accessor: "activityPart"
      },
      {
        Header: `${M}teacher`,
        accessor: "master"
      },
      {
        Header: "main.hour",
        accessor: "hour"
      }
    ]
  };
};
